import React, { useState, useEffect } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router";
import icon from "../assets/Icon.png";
import { url, url2 } from "../env";
import { getDelawareDate } from "../env";
import Loader from "../components/loader";
import Course from "../components/course";
import PopUp from "../components/popUp";
import Profile from "../components/profile";
import Department from "../components/department";
import Footer from "../components/footer";

export default function AdminDashboard() {

    const data = JSON.parse(localStorage.getItem("attendance_teacher")? localStorage.getItem("attendance_teacher") : sessionStorage.getItem("attendance_teacher"))

    const navigate = useNavigate();

    const handleBackButtonClick = (e) => {
        e.preventDefault();
        localStorage.removeItem("attendance_teacher");
        sessionStorage.removeItem("attendance_teacher");
        navigate(-1);
    };

    const [departs, setDeparts] = useState(null);
    const [loading, setLoading] = useState(null);

    const fetchAllDepts = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${url}Departments/Get`);
            const result = await response.json();
            setDeparts(result.Department);
            console.log(result.Department, "here")
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    const navigateToAllEmp = (item) => {
        navigate(`/all-teachers/${item.deptId}`, {
            state: {
                deptCode: item.deptCode,
                deptId: item.deptId,
                deptName: item.deptName,
                deptStatus: item.deptStatus,
                description:item.description
            },
        })
    }

    useEffect(() => {

        fetchAllDepts();
    }, []);
    return (
        <div className="all_departments">
            <div className="mainAllCoursesHeader">
                <div className="title">
                    <span className="date">السلام عليكم</span>
                    <span style={{textTransform:"uppercase"}} className="courseName">{data?.username}</span>
                </div>
                <div className="profile_icon_2" onClick={handleBackButtonClick} >
                    <TbLogout2 />
                </div>

                <div className="profile_icon">
                    <img src={icon} alt="Profile Icon" />
                </div>
            </div>

            <div className="all_departments_section">
                <h1>All Departments</h1>

                {

                    loading ? <>Loading</> :
                        departs && departs.map((item, index) => {
                            return (
                                <Department 
                                name={item.deptName} 
                                status={item.deptStatus} 
                                onClickFn={() =>navigateToAllEmp(item)} 
                            />
                            
                            )
                        })
                }

            </div>
           {/* <Footer/> */}
        </div>
    )
}